import styled from 'styled-components';

export const Content = styled.div`
  padding: 8px;
`;
